import { useParams } from "react-router-dom"
import AssetStatusHistory from "@hydrologiq/shared/asset/history/AssetStatusHistory"
import Informative from "@hydrologiq/shared/Informative"
import { useAsset } from "../hooks/useAsset"

function AssetHistory() {
  const { assetId } = useParams()

  const { asset } = useAsset(assetId)

  return !asset ? (
    <Informative heading="Asset not found" text="Please check the asset and try again." />
  ) : (
    <AssetStatusHistory asset={asset} />
  )
}

export default AssetHistory
